export default "__VITE_ASSET__D2Z$lYdr__"